/**
 * Dollars ⇄ cents for the price-list form.
 *
 * The table stores integer cents; the operator types dollars. These two
 * functions are the only place that conversion happens, and they are pure so
 * the rounding rule is testable on its own: `"166.005"` must become 16601
 * cents (round half up), never 16600.4999… stored as a float.
 */

/**
 * Parse a typed dollar amount into whole cents. Tolerates thousands
 * separators, a leading `$`, and surrounding whitespace — an operator pasting
 * "$4,410.00" out of the price book should not get a validation error.
 * Returns `null` when the text is not a number, so the caller can show the
 * field error instead of silently writing 0.
 */
export function dollarsToCents(text: string): number | null {
  const cleaned = text.replace(/[$,\s]/g, "");
  if (cleaned === "") return null;
  const value = Number(cleaned);
  if (!Number.isFinite(value) || value < 0) return null;
  // Round on the SCALED value: `Math.round(4410.005 * 100)` is exact enough,
  // while rounding dollars first would throw the sub-cent away.
  return Math.round(value * 100);
}

/** Cents → the dollar string the form field shows ("16600" → "166.00"). */
export function centsToDollarsInput(cents: number): string {
  return (cents / 100).toFixed(2);
}
